import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
    query DownloadBusinessWalletTransactions ($tenantId: String!, $page: Int, $limit: Int, $includeHeaderRow: Boolean) {
        businessWalletTransfersCSV(
            tenantId: $tenantId,
            page: $page,
            limit: $limit,
            includeHeaderRow: $includeHeaderRow
        ) {
            totalItemsCount
            data
        }
    }
`

export const businessWalletTransfersCSVKey = getQueryNames(query)[0]

export default query

